// extracted by mini-css-extract-plugin
export default {"localeGlobe":"localeGlobe__jYqSGK","localeTag":"localeTag__SNN67P"};